import { useTranslation } from "react-i18next";

const MONTH_KEYS = [
  "month-january",
  "month-february",
  "month-march",
  "month-april",
  "month-may",
  "month-june",
  "month-july",
  "month-august",
  "month-september",
  "month-october",
  "month-november",
  "month-december",
];

export function useMonthName() {
  const { t } = useTranslation();

  function getMonthName(monthNumber: number): string {
    if (monthNumber < 1 || monthNumber > 12) return "";
    return t(MONTH_KEYS[monthNumber - 1]);
  }

  return { getMonthName };
}
